import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import FooterLayout from "../footer/footerLayout";
import NavigationLayout from "../navigation/navigationLayout";
import FuzzyText from '../../components/animation/fuzzyText/fuzzyText';
import { useTranslation } from "react-i18next";
import ButtonComponent from "../../components/form/buttonComponent";
import { useNavigate } from "react-router-dom";

const NotFoundLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const navigate = useNavigate();

    return (
        <>
            <NavigationLayout />

            <Box
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 15, md: 20, lg: 25},
                    pb: {xs: 5, md: 10, lg: 15},
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                    spacing={4}
                >
                    <FuzzyText 
                        color={theme.palette.primary.main}
                        fontFamily="Montserrat"
                        fontSize={isMobile ? 100 : 300}
                        baseIntensity={0.5}
                        hoverIntensity={0}
                    >
                        404
                    </FuzzyText>

                    <Typography
                        fontWeight={500}
                        fontSize={{xs: 12, lg: 16}}
                        textAlign="center"
                        lineHeight={1.5}
                        color={theme.palette.text.secondary}
                        sx={{
                            pt: {xs: 0, md: 6}
                        }}
                    >
                        {t('notFound.description')}
                    </Typography>

                    <ButtonComponent 
                        label={t('notFound.home')}
                        onClick={() => {
                            navigate('/');
                        }}
                    />
                </Stack>
            </Box>

            <FooterLayout />
        </>
    );
}

export default NotFoundLayout;